import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Text } from 'src/Components'
import StatusBadge from 'src/Components/homeSearch/StatusBadge'

import styles from './StatusHeader.module.scss'

const propTypes = {
  className: PropTypes.string,
  listing: PropTypes.shape({
    status: PropTypes.string,
    updatedAtInWords: PropTypes.string,
  }),
}

const defaultProps = {
  className: '',
}

const StatusHeader = ({ listing, className }) => (
  <div className={classNames(styles.header, className)}>
    <StatusBadge status={listing.status} />
    <Text element='span' variant='neutralCool' variantCount='700' size='xs'>
      {listing.updatedAtInWords}
    </Text>
  </div>
)

StatusHeader.propTypes = propTypes
StatusHeader.defaultProps = defaultProps

export default StatusHeader
